import { GRR_DRAFT } from "../constants/statusCodes";

export const gameReportReferee = {
	gameName: null,
	town: null,
	location: null,
	gameDate: null,
	gameStart: null,
	gameEnd: null,
	teamInfoHome: {
		teamName: null,
		representative: null,
		gameManager: null,
		colorHelmets: null,
		colorShirts: null,
		colorPants: null,
		colorSocks: null,
		disqualifications: null
	},
	gameOfficials: {
		referee: null,
		centerjudge: null,
		umpire: null,
		linesman: null,
		linejudge: null,
		backjudge: null,
		fieldjudge: null,
		sidejudge: null,
		timekeeper: null,
		shotclock: null,
		observer: null
	},
	teamInfoAway: {
		teamName: null,
		representative: null,
		gameManager: null,
		colorHelmets: null,
		colorShirts: null,
		colorPants: null,
		colorSocks: null,
		disqualifications: null
	},
	periodScoresHome: [],
	periodScoresAway: [],
	equipmentHome: {
		isOk: null,
		facemaskColor: null,
		helmetsColor: null,
		helmetsDesign: null,
		jerseysColor: null,
		jerseysDesign: null,
		pantsColor: null,
		pantsDesign: null,
		socksColor: null,
		socksDesign: null
	},
	equipmentAway: {
		isOk: null,
		facemaskColor: null,
		helmetsColor: null,
		helmetsDesign: null,
		jerseysColor: null,
		jerseysDesign: null,
		pantsColor: null,
		pantsDesign: null,
		socksColor: null,
		socksDesign: null
	},
	fieldEquipment: {
		isOk: null,
		downBox: null,
		chain: null,
		pylons: null,
		yardageMarker: null,
		fieldMarkingsLines: null,
		fieldMarkingsCoachingBox: null,
		fieldMarkingsTeamArea: null
	},
	eventStaff: {
		isOk: null,
		medicalStaff: null,
		security: null,
		chainCrew: null,
		others: null
	},
	notesHome: {
		comment: null,
		name: null
	},
	notesOfficials: {
		mercyRulePeriod: null,
		mercyRuleTime: null,
		comment: null,
		comment2: null,
		name: null
	},
	notesAway: {
		comment: null,
		name: null
	}
};

export const gameReportRefereeMeta = {

	awayConfirmationAt: null,
	awayConfirmationBy: null,
	homeConfirmationAt: null,
	homeConfirmationBy: null,
	status:             GRR_DRAFT,
	statusChangedAt:    null,
	statusChangedBy:    null

};